import { render, staticRenderFns } from "./OrderByDropdown.vue?vue&type=template&id=4f0b4c33&lang=pug&"
import script from "./OrderByDropdown.vue?vue&type=script&lang=js&"
export * from "./OrderByDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports